module.exports = __webpack_public_path__ + "assets/img/report-content-bg3.4297c5c5.png";